/// <amd-module name="TFS/Admin/Views/ProfileSettings/SSHPublicKeysView/Components/DisplaySSHKeyDataPanel" />
import React = require("react");
import { Panel } from "VSSUI/Panel";
import { VssComponent } from "VSS/Platform/Layout";
import { localeFormat } from "VSS/Core/Util/String";
import { SSHToken } from "TFS/Admin/Views/ProfileSettings/SSHPublicKeysView/Contracts";
import * as Resources from "TFS/Admin/Views/ProfileSettings/SSHPublicKeysView/Resources";

export interface IProfileSSHPublicKeysProps {
    onDismiss: () => void;
    selectedToken: SSHToken;
}

export default class DisplaySSHKeyDataPanel extends VssComponent<IProfileSSHPublicKeysProps> {
    public render() {
        const { selectedToken: {token}, selectedToken } = this.props;
        return (
            <Panel
                onDismiss={this.props.onDismiss}
                titleProps={{ text: Resources.SSHKeyDataTitle }}
                footerButtonProps={[{
                    text: Resources.CloseBtn,
                    primary: true,
                    onClick: () => this.props.onDismiss()
                }]}
            >
                <div tabIndex={0}>
                    <h4>{Resources.Name}</h4>
                    <div>{token.displayName}</div>
                    <h4>{Resources.Fingerprint}</h4>
                    <div>{selectedToken.fingerprint}</div>
                    <h4>{Resources.KeyData}</h4>
                    <div className="key-data-text"> {token.publicData}</div>
                    <h4>{Resources.DateValidUntil}</h4>
                    <div>{localeFormat("{0}", token.validTo)}</div>
                    <h4>{Resources.DateAdded}</h4>
                    <div>{localeFormat("{0}", token.validFrom)}</div>
                </div>
            </Panel>
        );
    }
}
